/**
 * 获取URL参数
 * @param name - 参数名称（可选）
 * @returns 如果提供参数名，返回对应的参数值；如果未提供参数名，返回包含所有参数的对象
 * @example
 * // URL: https://example.com?foo=bar&baz=qux
 * getParam('foo') // 返回 'bar'
 * getParam() // 返回 { foo: 'bar', baz: 'qux' }
 */
export function getUrlParam(name?: string): string | Record<string, string> {
  try {
    const url = location.href;
    const questionMarkIndex = url.indexOf("?");

    // 如果URL中没有参数
    if (questionMarkIndex === -1) {
      return name === undefined ? {} : "";
    }

    const search = url
      .substring(questionMarkIndex + 1)
      .replace(/#\/|\?/gi, "&");
    const resObj: Record<string, string> = {};

    search.split("&").forEach((item) => {
      if (!item) return;

      const arr = item.split("=");
      if (arr.length >= 2) {
        const key = decodeURIComponent(arr[0].trim());
        const value = decodeURIComponent(arr[1].trim());
        if (key) {
          resObj[key] = value;
        }
      }
    });

    if (name === undefined) {
      return resObj;
    }

    return resObj[name] || "";
  } catch (error) {
    console.warn("getParam解析URL参数时发生错误:", error);
    return name === undefined ? {} : "";
  }
}
